var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCadastro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.214,
    height: 41.5,
    viewBox: "0 0 39.214 41.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-cadastro",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M156.81.459,140.835,16.434a1.713,1.713,0,0,0-.479,1.116l-.106,8.16a1.605,1.605,0,0,0,.478,1.17,1.7,1.7,0,0,0,1.116.532h.027l7.895-.159a1.647,1.647,0,0,0,1.116-.532l16.108-16.108a1.621,1.621,0,0,0,0-2.259L159.1.459A1.653,1.653,0,0,0,156.81.459ZM149.048,24.01l-5.582.08.08-5.848,8.134-8.134,5.609,5.688Zm10.5-10.5-5.609-5.688,3.987-3.987,5.635,5.635Z",
    transform: "translate(-128.235 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M29.727,23.378a1.595,1.595,0,0,0,0-3.19H13.778a1.6,1.6,0,0,0-1.595,1.595V58.2a1.6,1.6,0,0,0,1.595,1.595H43.549A1.6,1.6,0,0,0,45.144,58.2V43.314a1.595,1.595,0,1,0-3.19,0V56.6H15.373V23.378Z",
    transform: "translate(-12.183 -18.294)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCadastro);
export default __webpack_public_path__ + "static/media/menu-cadastro.2236a2ee562328f6f6aa65cadeb4b042.svg";
export { ForwardRef as ReactComponent };